import React from "react";
import PropTypes from "prop-types";
import { Button as LukButton, IconButton } from "@lukos-tecnologia/ui/ui";

/**
 * Adaptador de compatibilidade: o antigo Button do template (Material Dashboard)
 * agora renderiza o Button/IconButton padrão de @lukos-tecnologia/ui. Mantém a
 * API legada (`color`, `simple`, `block`, `justIcon`, `size`…) para não exigir
 * edição das dezenas de telas/tabelas que ainda o importam — padroniza todas de
 * uma vez. Código novo deve importar de `components/ui`.
 */
const COLOR_TO_VARIANT = {
  primary: "primary",
  behance: "primary",
  rose: "primary",
  main: "primary",
  success: "secondary",
  info: "secondary",
  warning: "secondary",
  danger: "danger",
  white: "ghost",
  transparent: "ghost",
  link: "link",
};

const ICON_COLOR_TO_VARIANT = { primary: "primary", danger: "danger" };

function RegularButton(props) {
  const {
    color,
    round,
    children,
    fullWidth,
    disabled,
    simple,
    size,
    block,
    link,
    justIcon,
    className,
    muiClasses,
    width,
    style,
    title,
    "aria-label": ariaLabel,
    ...rest
  } = props;

  // round/muiClasses: desestruturados só para NÃO vazarem como atributos no DOM.
  void round;
  void muiClasses;

  // Botão só-ícone (ex.: ações de tabela) → IconButton da lib.
  if (justIcon) {
    return (
      <IconButton
        aria-label={ariaLabel || title || "Ação"}
        title={title}
        variant={ICON_COLOR_TO_VARIANT[color] || "default"}
        className={className}
        disabled={disabled}
        style={style}
        {...rest}
      >
        {children}
      </IconButton>
    );
  }

  let variant = COLOR_TO_VARIANT[color] || "primary";
  if (simple || link) variant = "text";

  const wantsFull = block || fullWidth || width === "100%" || width === 100;
  const mergedStyle = wantsFull ? { width: "100%", ...style } : style;
  const libSize = size === "lg" ? "lg" : size === "sm" ? "sm" : "md";

  return (
    <LukButton
      variant={variant}
      size={libSize}
      disabled={disabled}
      className={className}
      style={mergedStyle}
      {...rest}
    >
      {children}
    </LukButton>
  );
}

RegularButton.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  simple: PropTypes.bool,
  round: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  justIcon: PropTypes.bool,
  className: PropTypes.string,
  muiClasses: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  title: PropTypes.string,
  "aria-label": PropTypes.string,
  children: PropTypes.node,
};

export default RegularButton;
